/**
 * For one page that shows Needs-you items one at a time (#1774): a function that reports each gate id it is given as
 * viewed, once for the life of the page, however often a poll or a re-read shows it again. A report that fails, or
 * throws, is swallowed, so it never breaks the page showing the item.
 */
export function viewedOncePerPage(report: (gateId: string) => Promise<void> | void): (gateId: string) => void {
    const reported = new Set<string>()
    return gateId => {
        if (reported.has(gateId)) {
            return
        }
        reported.add(gateId)
        try {
            void Promise.resolve(report(gateId)).catch((): undefined => undefined)
        } catch {
            // A report that cannot even be sent changes nothing on the page.
        }
    }
}
